import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import Menu from 'PMT/entities/menu/Menu';

export default class MenuRow extends Component {

  static propTypes = {
    menu: PropTypes.instanceOf(Menu).isRequired,

    onDelete: PropTypes.func.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.menu.equals(this.props.menu);
  }

  onDisplayDetailClick = () => {
    RouteAction.presentMenuDetail(this.menu);
  };

  get menu() {
    return this.props.menu;
  }

  // -- renderers

  render() {
    return (
      <li>
        <h4 className="link-hover"
          onClick={this.onDisplayDetailClick}
        >
          {this.menu.name}
        </h4>
        <i
          onClick={() => { this.props.onDelete(this.props.menu); }}
          className="fa fa-trash pointer"
        />
      </li>
    );
  }

}
